import { ethereumApi } from '@yozh-io/1inch-widget-api-client';

import { fetchOneInchQuote } from '../';
import { OneInchQuoteInfo, UpdateOneInchParams } from '../types';

export const getOneInchQuote = async (params: UpdateOneInchParams): Promise<OneInchQuoteInfo> => {
  const quote: ethereumApi.QuoteResponseDto = await fetchOneInchQuote({
    chainId: params.chainId,
    quoteInfo: { ...params },
  });
  console.log('%c ONE_INCH QUOTE: ', 'background: #221130; color: #cb8cff', quote);
  return {
    toTokenAmount: quote.toTokenAmount,
    estimatedGas: String(quote.estimatedGas),
    route: quote.protocols,
  };
};
